import { z } from "zod";

/**
 * Can also be void when not found....
 */
export const backofficeLastPointResponseSchema = z
  .object({
    dateMeter: z.coerce.date().nullable(),
    powerValue1: z.number().nullable(),
    powerValue2: z.number().nullable(),
    powerValue3: z.number().nullable(),
    powerValue4: z.number().nullable(),
    powerValue5: z.number().nullable(),
    powerValue6: z.number().nullable(),
  })
  .or(z.void());

export type BackofficeLastPointResponse = z.infer<typeof backofficeLastPointResponseSchema>;
